<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the LVB specific component for rendering the Duty activity start line (first line in a block)    -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row v-if="hasTrueChildren" dense>
    <v-col cols="2">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
    <v-col cols="3">{{ dutyActivity.activityShortname }}</v-col>
    <v-col cols="7">{{ dutyStopsById[dutyActivity.startStopIdFk].shortname }}</v-col>
  </v-row>
  <v-row v-else dense>
    <v-col cols="2">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
    <v-col cols="3">{{ dutyActivity._startStop && dutyActivity._startStop.shortname }}</v-col>
    <v-col cols="2">{{ time(dutyActivity.toMinutesAfterMidnight) }}</v-col>
    <v-col cols="3">{{ dutyActivity._endStop && dutyActivity._endStop.shortname }}</v-col>
    <v-col cols="2" class="dense-course">{{ dutyActivity.blockcode }}</v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityStart_Blt',
  components: {},
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    isParent: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
